import styled from 'styled-components'

export const FilterContainer = styled.div`
  & > form {
    width: 100%;
  }
`
